import { useTheme } from "@emotion/react";
import { ApartmentOutlined, LocalOfferOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  LinearProgress,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import MentionTextField from "../../textfieldMention";
import VirtualizedAutocomplete from "../../virtualization/virtualizedAutocomplete";
import { CampoCliente, renderOpcaoCliente } from "../../opcaoCliente";
import { getClienteOptionLabel } from "../../grupoEconomico/helpers";
import useStyles from "./styles";
export default function EditTicketComponentIxc(params) {
  const {
    clientes = [],
    loadingServicos = false,
    loadingCreateTicket = false,
    loadingParams = false,
    setServicos = () => {},
    servicos = [],
    setDataTicket = () => {},
    dataTicket = {},
    error = false,
    isEdit = false,
    prioridades = [],
    prioridadesOs = [],
    status = [],
    statusOs = [],
    logins = [],
    filiais = [],
    departamentos = [],
    setores = [],
    assuntos = [],
    horarios = [],
    isOs = false,
    loadingLogins = false,
    disabledCliente = false,
    // Id do ERP escolhido na tela; vai no body das rotas.
    erpId,
  } = params;
  const theme = useTheme();

  const styles = useStyles(theme);
  const [valueOrigemEndereco, setValueOrigemEndereco] = useState(
    dataTicket?.origem_endereco || "M",
  );
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingEndereco, setLoadingEndereco] = useState(false);
  const [loadingFuncionarios, setLoadingFuncionarios] = useState(false);
  // O estado guarda só o clienteErpId; o objeto completo é usado em dois
  // lugares do autocomplete — como `value` e para montar o selo do campo.
  const clienteSelecionado =
    clientes.find(
      (c) =>
        c.clienteErpId === dataTicket?.clienteErpId &&
        (!erpId || c.erpId === erpId),
    ) || null;

  useEffect(() => {
    setDataTicket((prev) => ({
      ...prev,
      origem_endereco: valueOrigemEndereco,
    }));

    if (
      (valueOrigemEndereco === "C" ||
        valueOrigemEndereco === "L" ||
        valueOrigemEndereco === "CC") &&
      dataTicket?.clienteErpId
    ) {
      getEndereco(valueOrigemEndereco, dataTicket?.clienteErpId);
    }
  }, [valueOrigemEndereco]);

  useEffect(() => {
    if (dataTicket?.departamentoId) {
      getColaborador(dataTicket?.departamentoId);
    }
  }, [dataTicket?.departamentoId]);

  useEffect(() => {
    if (!isEdit) {
      setDataTicket((prev) => ({
        ...prev,
        statusId: isOs ? "A" : "N",
        horarioId: "Q",
      }));
    }
  }, []);

  const getEndereco = async (origemEndereco, clienteErpId) => {
    setLoadingEndereco(true);
    try {
      const response = await api.post("/interno/find/origemEndereco", {
        enderecoOrigem: origemEndereco,
        clienteErpId: clienteErpId,
        loginId: dataTicket?.loginId,
        serviceId: dataTicket?.clienteServicoId,
        erpId,
      });

      setDataTicket((prev) => ({
        ...prev,
        endereco: response?.data || "",
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingEndereco(false);
    }
  };

  const getColaborador = async (idSetor) => {
    setLoadingFuncionarios(true);
    try {
      const response = await api.post("/interno/find/funcionarios", {
        idSetor: idSetor,
        isOs: isOs,
        erpId,
      });

      setFuncionarios(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFuncionarios(false);
    }
  };

  const handleChangeOrigemEndereco = (event) => {
    setValueOrigemEndereco(event.target.value);
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        height: "79%",
        borderRadius: "16px",
        p: 0.8,
        position: "relative",
        overflow: "hidden",
        backgroundColor:
          theme.palette.mode === "dark"
            ? alpha(theme.palette.colors.black.dark, 0.4)
            : theme.palette.colors.black.lighter,
      }}
    >
      <Box sx={styles.paperItens}>
        <Grid
          container
          spacing={2}
          columns={{
            xs: 6,
            sm: 6,
            smx: 6,
            md: 6,
            lg: 6,
            xl: 6,
            xxl: 6,
          }}
        >
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ApartmentOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados cadastrais
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            {isEdit || disabledCliente ? (
              <TextField
                disabled
                variant="filled"
                size="small"
                label="Cliente"
                value={dataTicket?.nome || ""}
                sx={{ width: "100%" }}
              />
            ) : (
              <VirtualizedAutocomplete
                size="small"
                options={clientes}
                disabled={loadingServicos || loadingCreateTicket}
                value={clienteSelecionado}
                // Garante a comparação correta entre a opção e o valor selecionado
                isOptionEqualToValue={(option, value) =>
                  option.clienteErpId === value.clienteErpId
                }
                getOptionLabel={(option) => getClienteOptionLabel(option)}
                onChange={(event, value) => {
                  if (!value) {
                    setServicos([]);
                    setDataTicket((prev) => ({
                      ...prev, // Mantém os outros campos
                      clienteErpId: null,
                      cnpj: null,
                      nome: null,
                      clienteServicoId: null,
                      loginId: null,
                      origem_endereco: null,
                      endereco: null,
                    }));
                    setValueOrigemEndereco("M");
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    clienteErpId: value.clienteErpId || null,
                    cnpj: value.cnpj || null,
                    nome: value.nome || null,
                  }));
                }}
                sx={{ width: "100%" }}
                renderOption={renderOpcaoCliente()}
                renderInput={(params) => (
                  <CampoCliente
                    params={params}
                    option={clienteSelecionado}
                    variant="filled"
                    error={error && !dataTicket?.clienteErpId}
                    helperText={
                      error && !dataTicket?.clienteErpId && "Campo obrigatório"
                    }
                    label="Cliente"
                  />
                )}
              />
            )}
          </Grid>
          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <Autocomplete
                size="small"
                options={servicos}
                disabled={
                  !dataTicket?.clienteErpId ||
                  loadingServicos ||
                  loadingCreateTicket
                }
                value={
                  servicos?.find(
                    (servico) =>
                      servico?.id_cliente_servico ===
                      dataTicket?.clienteServicoId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome || ""}`
                    : ""
                }
                onChange={(event, value) => {
                  if (!value) {
                    setDataTicket((prev) => ({
                      ...prev,
                      clienteServicoId: null,
                      telefone: null,
                      email: null,
                      enderecoInstalacao: null,
                      loginId: null,
                    }));
                    if (dataTicket?.origem_endereco === "CC") {
                      setDataTicket((prev) => ({
                        ...prev,
                        origem_endereco: "M",
                      }));
                      setValueOrigemEndereco("M");
                    }
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    clienteServicoId: value?.id_cliente_servico || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Contrato"
                    error={error && !dataTicket?.clienteServicoId}
                    helperText={
                      error &&
                      !dataTicket?.clienteServicoId &&
                      "Campo obrigatório"
                    }
                  />
                )}
                filterOptions={(options, params) => {
                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.id?.toString().includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico || option.id} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico || option.id} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                Descrição auxiliar:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />

              {loadingServicos && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>

          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={logins}
                disabled={
                  loadingLogins ||
                  loadingCreateTicket ||
                  !dataTicket?.clienteServicoId
                }
                value={
                  logins?.find((login) => login?.id === dataTicket?.loginId) ||
                  null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.id} - ${option?.login}` : ""
                }
                onChange={(event, value) => {
                  if (!value) {
                    setDataTicket((prev) => ({
                      ...prev,
                      loginId: null,
                    }));
                    if (dataTicket?.origem_endereco === "L") {
                      setDataTicket((prev) => ({
                        ...prev,
                        origem_endereco: "M",
                      }));
                      setValueOrigemEndereco("M");
                    }
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    loginId: value?.id || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Login"
                    /* error={error && !dataTicket?.clienteServicoId}
                    helperText={
                      error &&
                      !dataTicket?.clienteServicoId &&
                      "Campo obrigatório"
                    } */
                  />
                )}
              />

              {loadingLogins && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={filiais}
                disabled={loadingParams || loadingCreateTicket}
                value={
                  filiais?.find(
                    (filial) => filial?.id === dataTicket?.filialId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.id} - ${option?.razao}` : ""
                }
                onChange={(event, value) => {
                  if (!value) {
                    setDataTicket((prev) => ({
                      ...prev,
                      filialId: null,
                    }));
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    filialId: value?.id || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Filial"
                    error={error && !dataTicket?.filialId}
                    helperText={
                      error && !dataTicket?.filialId && "Campo obrigatório"
                    }
                  />
                )}
              />

              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                Origem do endereço
              </FormLabel>
              <RadioGroup
                row
                value={valueOrigemEndereco}
                onChange={handleChangeOrigemEndereco}
              >
                <FormControlLabel
                  disabled={!dataTicket?.clienteErpId || loadingCreateTicket}
                  value="C"
                  control={<Radio />}
                  label="Cliente"
                />
                <FormControlLabel
                  disabled={
                    !dataTicket?.clienteErpId ||
                    !dataTicket?.clienteServicoId ||
                    loadingCreateTicket
                  }
                  value="CC"
                  control={<Radio />}
                  label="Contrato"
                />
                <FormControlLabel
                  disabled={
                    !dataTicket?.clienteErpId ||
                    !dataTicket?.loginId ||
                    loadingCreateTicket
                  }
                  value="L"
                  control={<Radio />}
                  label="Login"
                />

                <FormControlLabel
                  value="M"
                  control={<Radio />}
                  label="Manual"
                  disabled={loadingCreateTicket}
                />
              </RadioGroup>
            </FormControl>
            <Box sx={styles.boxTextField}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                variant="filled"
                label="Endereço"
                value={dataTicket?.endereco || ""}
                onChange={(e) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    endereco: e.target.value,
                  }));
                }}
                disabled={
                  dataTicket?.origem_endereco !== "M" || loadingCreateTicket
                }
                helperText={
                  error && !dataTicket?.endereco && "Campo obrigatório"
                }
                error={error && !dataTicket?.endereco}
              />
              {loadingEndereco && <LinearProgress sx={styles.linearProgres} />}
            </Box>{" "}
          </Grid>

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Divider />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalOfferOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados do {isOs ? "OS" : "Ticket"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={assuntos}
                value={
                  assuntos?.find(
                    (item) => item?.id === dataTicket?.assuntoId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.assunto || ""} ` : ""
                }
                disabled={loadingParams || loadingCreateTicket}
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    assuntoId: value?.id || null,
                    titulo: value?.assunto || "",
                  }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    variant="filled"
                    error={error && !dataTicket?.assuntoId}
                    helperText={
                      error && !dataTicket?.assuntoId && "Campo obrigatório"
                    }
                    {...params}
                    label="Assunto"
                  />
                )}
              />
              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              {isOs ? (
                <VirtualizedAutocomplete
                  size="small"
                  options={setores}
                  value={
                    setores?.find(
                      (item) => item?.id === dataTicket?.departamentoId,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) =>
                    option ? `${option?.setor || ""} ` : ""
                  }
                  disabled={loadingParams || loadingCreateTicket}
                  onChange={(event, value) => {
                    setDataTicket((prev) => ({
                      ...prev,
                      departamentoId: value?.id || null,
                      responsavelId: "",
                    }));
                  }}
                  sx={{
                    width: "100%",
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="filled"
                      error={error && !dataTicket?.departamentoId}
                      helperText={
                        error &&
                        !dataTicket?.departamentoId &&
                        "Campo obrigatório"
                      }
                      {...params}
                      label="Setor"
                    />
                  )}
                />
              ) : (
                <VirtualizedAutocomplete
                  size="small"
                  options={departamentos}
                  value={
                    departamentos?.find(
                      (item) => item?.id === dataTicket?.departamentoId,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) =>
                    option ? `${option?.setor || ""} ` : ""
                  }
                  disabled={loadingParams || loadingCreateTicket}
                  onChange={(event, value) => {
                    setDataTicket((prev) => ({
                      ...prev,
                      departamentoId: value?.id || null,
                      responsavelId: "",
                    }));
                  }}
                  sx={{
                    width: "100%",
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="filled"
                      error={error && !dataTicket?.departamentoId}
                      helperText={
                        error &&
                        !dataTicket?.departamentoId &&
                        "Campo obrigatório"
                      }
                      {...params}
                      label="Departamento"
                    />
                  )}
                />
              )}

              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={isOs ? prioridadesOs : prioridades}
                value={
                  isOs
                    ? prioridadesOs?.find(
                        (item) => item?.id === dataTicket?.prioridadeId,
                      ) || null
                    : prioridades?.find(
                        (item) => item?.id === dataTicket?.prioridadeId,
                      ) || null
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) =>
                  option ? `${option?.prioridade || ""} ` : ""
                }
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    prioridadeId: value?.id || null,
                  }));
                }}
                sx={{
                  width: "100%",
                }}
                disabled={loadingParams || loadingCreateTicket}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    variant="filled"
                    error={error && !dataTicket?.prioridadeId}
                    helperText={
                      error && !dataTicket?.prioridadeId && "Campo obrigatório"
                    }
                    {...params}
                    label="Prioridade"
                  />
                )}
              />
              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>

          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={horarios}
                disabled={loadingParams || loadingCreateTicket}
                value={
                  horarios.find((item) => item.id === dataTicket?.horarioId) ||
                  null
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option?.horario || ""}
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    horarioId: value?.id || "",
                  }));
                }}
                sx={{ width: "100%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Melhor horário "
                  />
                )}
              />
              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <MentionTextField
              disabled={loadingCreateTicket}
              value={dataTicket?.descricaoAbertura || ""}
              onChange={(value) =>
                setDataTicket((prev) => ({
                  ...prev,
                  descricaoAbertura: value,
                }))
              }
              typeMetion={isOs ? "os" : "ticket"}
              label="Descrição de abertura"
              variant="filled"
              InputProps={{
                inputComponent: "textarea",
              }}
              /*   disabled={loadingCreateTicket || loadingParams} */
              error={
                error &&
                (!dataTicket?.descricaoAbertura ||
                  dataTicket?.descricaoAbertura.length < 10)
              }
              helperText={
                (error &&
                  !dataTicket?.descricaoAbertura &&
                  "Campo obrigatório") ||
                (error &&
                  dataTicket?.descricaoAbertura?.length > 0 &&
                  dataTicket?.descricaoAbertura.length < 10 &&
                  "A descrição deve ter no mínimo 10 caracteres")
              }
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  paddingTop: "25px",
                  paddingRight: "5px",
                  paddingBottom: "5px",
                },
                "& textarea": {
                  resize: "vertical",
                  minHeight: "80px",
                  padding: "10px 12px",
                },
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} smx={4} md={4} lg={4} xl={4} xxl={4}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                disabled={
                  !dataTicket?.departamentoId ||
                  loadingFuncionarios ||
                  loadingCreateTicket
                }
                options={funcionarios}
                value={
                  funcionarios?.find(
                    (item) => item?.id === dataTicket?.responsavelId,
                  ) || null
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) =>
                  option ? `${option?.funcionario || ""} ` : ""
                }
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    responsavelId: value?.id || null,
                  }));
                }}
                sx={{
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    variant="filled"
                    error={error && !dataTicket?.responsavelId}
                    helperText={
                      error && !dataTicket?.responsavelId && "Campo obrigatório"
                    }
                    {...params}
                    label="Colaborador responsável"
                  />
                )}
              />
              {loadingFuncionarios && (
                <LinearProgress sx={styles.linearProgres} />
              )}
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} smx={2} md={2} lg={2} xl={2} xxl={2}>
            <Box sx={styles.boxTextField}>
              {isOs ? (
                <VirtualizedAutocomplete
                  size="small"
                  options={statusOs}
                  value={
                    statusOs?.find(
                      (item) => item?.id === dataTicket?.statusId,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) =>
                    option ? `${option?.status || ""} ` : ""
                  }
                  onChange={(event, value) => {
                    setDataTicket((prev) => ({
                      ...prev,
                      statusId: value?.id || null,
                    }));
                  }}
                  sx={{
                    width: "100%",
                  }}
                  disabled={loadingParams || loadingCreateTicket || !isEdit}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="filled"
                      error={error && !dataTicket?.statusId}
                      helperText={
                        error && !dataTicket?.statusId && "Campo obrigatório"
                      }
                      {...params}
                      label="Status"
                    />
                  )}
                />
              ) : (
                <VirtualizedAutocomplete
                  size="small"
                  options={status}
                  value={
                    status?.find((item) => item?.id === dataTicket?.statusId) ||
                    null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) =>
                    option ? `${option?.status || ""} ` : ""
                  }
                  onChange={(event, value) => {
                    setDataTicket((prev) => ({
                      ...prev,
                      statusId: value?.id || null,
                    }));
                  }}
                  sx={{
                    width: "100%",
                  }}
                  disabled={loadingParams || loadingCreateTicket || !isEdit}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="filled"
                      error={error && !dataTicket?.statusId}
                      helperText={
                        error && !dataTicket?.statusId && "Campo obrigatório"
                      }
                      {...params}
                      label="Status"
                    />
                  )}
                />
              )}

              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
